export default "__VITE_ASSET__qLwdp6fH__"